import { render, staticRenderFns } from "./TableForm.vue?vue&type=template&id=54762326"
import script from "./TableForm.vue?vue&type=script&lang=js"
export * from "./TableForm.vue?vue&type=script&lang=js"
import style0 from "./TableForm.vue?vue&type=style&index=0&id=54762326&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports